import React from 'react'
import TestingStep from '../../components/Projects/Steps/TestingStep'

const TestingStepPage = () => {
  return (
    <div>
      <TestingStep/>
    </div>
  )
}

export default TestingStepPage